"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusText = void 0;
const messages_1 = require("../../../core/i18n/messages");
const getStatusText = (flags, formatMessage) => {
    if (flags.isCompleted) {
        return formatMessage({ id: messages_1.AppMessages['job.status.completed'] });
    }
    if (flags.isFailed) {
        return formatMessage({ id: messages_1.AppMessages['job.status.failed'] });
    }
    if (flags.isActive || flags.isWaiting) {
        return formatMessage({ id: messages_1.AppMessages['job.status.processing'] });
    }
    if (flags.isNotFound) {
        return formatMessage({ id: messages_1.AppMessages['job.status.notFound'] });
    }
    return formatMessage({ id: messages_1.AppMessages['job.status.unknown'] });
};
exports.getStatusText = getStatusText;
